import { httpClient } from "@bw/shared/api";
import type {
  DeletionRequestPage,
  DeletionRequestResponse,
  MessagePurgeRequest,
  MessagePurgeResponse,
} from "@bw/shared/types/generated";

export type {
  DeletionRequestPage,
  DeletionRequestResponse,
  MessagePurgeRequest,
  MessagePurgeResponse,
};

export interface ListDeletionRequestsParams {
  status?: string;
  limit?: number;
  offset?: number;
}

/**
 * Thin wrapper over GET /platform/compliance/deletions (platform_admin only).
 * httpClient prefixes /bff/api, so we pass a backend-space path. Mirrors
 * `modules/users/api` listUsers: unset params are omitted entirely; an empty
 * status string ("All") is treated as unset; an explicit `offset=0` is
 * preserved (0 is a real cursor position, not "unset").
 */
export async function listDeletionRequests(
  params?: ListDeletionRequestsParams,
): Promise<DeletionRequestPage> {
  const sp = new URLSearchParams();
  if (params?.status) sp.set("status", params.status);
  if (params?.limit !== undefined) sp.set("limit", String(params.limit));
  if (params?.offset !== undefined) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return httpClient.get<DeletionRequestPage>(
    `/platform/compliance/deletions${qs ? `?${qs}` : ""}`,
  );
}

/**
 * Irreversibly removes the payload of one already-known direct message.
 * This deliberately exposes no discovery or read path in Platform.
 */
export async function purgeMessageContent(
  messageId: string,
  request: MessagePurgeRequest,
): Promise<MessagePurgeResponse> {
  return httpClient.post<MessagePurgeResponse>(
    `/platform/compliance/messages/${encodeURIComponent(messageId)}/purge`,
    request,
  );
}
